import React from "react";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import SpecialButton from "../UI/SpecialButton";

import "./Services.scss";

const Services = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <div className="services-section">
      <ReactSVG
        className="ortho-icon-side"
        src="/icons/tools/orthoicon-side.svg"
      />
      <ReactSVG className="icon-ortho" src="/icons/menu/orthoicon.svg" />
      <h2 className="heading-services">
        Orthopedic Services that you can trust
      </h2>
      <div className="about_line"></div>

      <p className="services-paragraph">
        SecondLook Ortho provides patients a second opinion related to their
        orthopedic injury, diagnosis and/or treatment options. We hope to offer
        clarity and guidance to help you make the best decision on how to
        proceed with your care.
      </p>
      <SpecialButton
        className="button-get-started"
        buttonAsLink={true}
        link={isAuthenticated ? "/consultation-form" : "/sign-in"}
      >
        GET STARTED
      </SpecialButton>
    </div>
  );
};

export default Services;
